<template>
    <section class="bubly-side">
        <div class="bubly-side__title">
            <img src="./../assets/bublyside/text-lockup.png" alt="see the bubly side" />
        </div>
        <div class="bubly-side__cans">
            <img src="./../assets/bublyside/cans.png" alt="Blackberry, lime and grapefruit bubly cans" />
        </div>
    </section>
</template>

<script>
export default {
    name: "see-bubly-side"
}
</script>

<style lang='scss' scoped>
@import './../variables';
.bubly-side {
    height: 150vw;
    background-color: $flavor-lime-can;
    background-image: url(./../assets/bublyside/packs-bubbles-mobile.png);
    background-repeat: no-repeat;
    background-position: center bottom;
    background-size: contain;
    display: flex;
    flex-direction: column;
    align-items: center;

    img{
        width: 100%;
    }

    &__title {
        width: 85vw;
        margin-top: 13vw;
        margin-bottom: 6vw;
    }

    &__cans {
        width: 85vw;
        height: auto;
    }

    @media(min-width: 768px) {
        height: 135vw;
        background-image: url(./../assets/bublyside/packs-bubbles-tablet.png);

        &__title {
            width: 75vw;
            margin-top: 13vw;
        }

        &__cans {
            width: 75vw;

        }
    }

    @media(min-width: 1024px) {
        background-image: url(./../assets/bublyside/packs-bubbles-tablet-landscape.png);
        flex-direction: row;
        align-items: center;
        height: 75vw;
        
        &__title {
            margin: 0 4vw;
        }

        &__cans {
            margin: 0 4vw 0 0;
        }
    }

    @media(min-width: 1366px) {
        height: 50vw;
        min-height: 668px;
        background-image: url(./../assets/bublyside/packs-bubbles.png);
        justify-content: space-evenly;

        &__title {
            width: 38vw;
        }

        &__cans {
            width: 38vw;
        }
    }

    @media(min-width: 2560px) {
        background-image: url(./../assets/bublyside/packs-bubbles-ultra-wide.png);
        height: 35vw;
        justify-content: center;
        &__title {
            width: 28vw;
        }

        &__cans {
            width: 28vw;
        }
    }
} 

</style>


// WEBPACK FOOTER //
// src/components/SeeBublySide.vue